import React, { createContext, useCallback, useEffect } from 'react'
import { Message } from '@iqueue/ui-kit'
import useSocket from '../hooks/useSocket'
import { t } from '../hooks/useTranslate'

const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const socket = useSocket()
  const isDev = process.env.REACT_APP_ENV === 'development'

  const noticeMessages = useCallback((message) => {
    Message({
      type: message.type === "CRITICAL" ? 'error' : 'warning',
      timeout: isDev ? 1000 : 0,
      subtitle: 'Серийный номер: ' + message?.sensor.serialNumber,
      title: t(`status.sensor.${ message.context.body }`),
    })
  }, [isDev])

  useEffect(() => {
    socket.on('notice', noticeMessages)
    return () => {
      socket.off('notice', noticeMessages)
    }
  }, [socket, noticeMessages])

  return <NotificationContext.Provider value={ noticeMessages }>
    { children }
  </NotificationContext.Provider>
}
